import { useEffect, useState } from "react";
import Reports from "../components/reports";
import { FIU_REPORT_DATA } from "../constants/data.cnst";
import { TABLE_COLUMNS_CONFIG, type ColumnMeta } from "../constants/table.cnst";
import type { FIU_REPORT } from "../interfaces/dashboard";

export default function FIU() {
    const fIUReportTableColumns: ColumnMeta[] = TABLE_COLUMNS_CONFIG.FIU_REPORT;

    const [fIUReportTableData, setFIUReportTableData] = useState<FIU_REPORT[]>([]);

    useEffect(() => {
        setFIUReportTableData(FIU_REPORT_DATA)
    }, []);

    return (
        <Reports
        reportType='FIU'
        tableColumns={fIUReportTableColumns}
        tableData={fIUReportTableData} />
    );
}